import { useLanguage } from '../context/LanguageContext';

export const ImprintPage = () => {
  const { isRTL } = useLanguage();

  return (
    <div className="min-h-screen pt-16" data-testid="imprint-page">
      <section className="py-16 md:py-24 bg-white">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <h1 className={`text-4xl font-bold text-slate-900 font-heading mb-8 ${isRTL ? 'text-right' : 'text-left'}`}>
            Imprint
          </h1>
          
          <div className={`prose prose-slate max-w-none ${isRTL ? 'text-right' : 'text-left'}`}>
            <h2 className="text-xl font-semibold text-slate-900 mt-8 mb-4">Company Information</h2>
            <p className="text-slate-600 mb-4">
              GermanExpo Solutions<br />
              Export Mediation Services<br />
              Germany
            </p>

            <h2 className="text-xl font-semibold text-slate-900 mt-8 mb-4">Contact</h2>
            <p className="text-slate-600 mb-4">
              Email: info@germanexpo.com
            </p>

            <h2 className="text-xl font-semibold text-slate-900 mt-8 mb-4">Responsible for Content</h2>
            <p className="text-slate-600 mb-4">
              GermanExpo Solutions Management
            </p>

            <h2 className="text-xl font-semibold text-slate-900 mt-8 mb-4">Disclaimer</h2>
            <p className="text-slate-600 mb-4">
              The contents of our pages have been created with the utmost care. However, we cannot guarantee 
              the contents' accuracy, completeness, or topicality. According to statutory provisions, we are 
              furthermore responsible for our own content on these web pages.
            </p>
            <p className="text-slate-600 mb-4">
              In this matter, please note that we are not obliged to monitor the transmitted or saved 
              information of third parties, or investigate circumstances pointing to illegal activity. 
              Our obligations to remove or block the use of information under generally applicable laws 
              remain unaffected by this.
            </p>

            <h2 className="text-xl font-semibold text-slate-900 mt-8 mb-4">Copyright</h2>
            <p className="text-slate-600">
              Contents and compilations published on these websites by the providers are subject to German 
              copyright laws. Reproduction, editing, distribution as well as the use of any kind outside 
              the scope of the copyright law require a written permission of the author or originator.
            </p>
          </div>
        </div>
      </section>
    </div>
  );
};
